import { BaseNumber, promiseAll } from '@sparkdotfi/common-universal'
import { QueryKey } from '@tanstack/react-query'
import { Config } from 'wagmi'
import { readContract } from 'wagmi/actions'

import { sparkVaultV2Abi } from '@/config/contracts-generated'
import { Token } from '@/domain/types/Token'

export interface SavingsV2DepositDataQueryKeyParams {
  chainId: number
  savingsToken: Token
}

export function savingsV2DepositDataQueryKey({ chainId, savingsToken }: SavingsV2DepositDataQueryKeyParams): QueryKey {
  return ['savings-v2-deposit-data-query', chainId, savingsToken.symbol]
}

export interface SavingsV2DepositDataQueryFunctionParams {
  wagmiConfig: Config
  savingsToken: Token
  underlyingToken: Token
  chainId: number
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function savingsV2DepositDataQueryFunction({
  wagmiConfig,
  savingsToken,
  underlyingToken,
  chainId,
}: SavingsV2DepositDataQueryFunctionParams) {
  const { depositCap, totalSupply } = await promiseAll(
    {
      depositCap: () =>
        readContract(wagmiConfig, {
          address: savingsToken.address,
          abi: sparkVaultV2Abi,
          functionName: 'depositCap',
          chainId,
        }),
      totalSupply: () =>
        readContract(wagmiConfig, {
          address: savingsToken.address,
          abi: sparkVaultV2Abi,
          functionName: 'totalSupply',
          chainId,
        }),
    },
    { concurrency: 'unbounded' },
  )

  return {
    totalSupply: BaseNumber(totalSupply).toNormalizedUnit(underlyingToken.decimals),
    depositCap: BaseNumber(depositCap).toNormalizedUnit(underlyingToken.decimals),
  }
}
